import { userStore } from "../userStore"

export const useUserStore = () => {
  const keycloakUserId = userStore((state) => state.keycloakUserId)
  const userId = userStore((state) => state.userId)
  const userEmail = userStore((state) => state.userEmail)
  const name = userStore((state) => state.name)
  const tenantId = userStore((state) => state.tenantId)
  const orgId = userStore((state) => state.orgId)
  const orgName = userStore((state) => state.orgName)
  const orgCreated = userStore((state) => state.orgCreated)
  const workspaceUrl = userStore((state) => state.workspaceUrl)
  const role = userStore((state) => state.role)
  const permissions = userStore((state) => state.permissions)
  const siteIds = userStore((state) => state.siteIds)
  const permissionsLoaded = userStore((state) => state.permissionsLoaded)

  const setUserData = userStore((state) => state.setUserData)
  const fetchUserPermissions = userStore((state) => state.fetchUserPermissions)
  const setOrgId = userStore((state) => state.setOrgId)
  const setOrgName = userStore((state) => state.setOrgName)
  const setOrgCreated = userStore((state) => state.setOrgCreated)
  const setWorkspaceUrl = userStore((state) => state.setWorkspaceUrl)
  const clearUserData = userStore((state) => state.clearUserData)

  return {
    keycloakUserId,
    userId,
    userEmail,
    name,
    tenantId,
    orgId,
    orgName,
    orgCreated,
    workspaceUrl,
    role,
    permissions,
    siteIds,
    permissionsLoaded,
    setUserData,
    fetchUserPermissions,
    setOrgId,
    setOrgName,
    setOrgCreated,
    setWorkspaceUrl,
    clearUserData,
  }
}

export default useUserStore
